import React from "react";
import { ToastContainer } from "react-toastify";
import { ManageContact } from "../../components/Contact/ManageContact";
export const ContactManage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ManageContact />
        </div>
      </div>
    </div>
  );
};